<template>
  <button
    class="button"
    :class="buttonClasses"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  type: { type: String, required: false, default: "primary" },
  disabled: { type: Boolean, required: false, default: false },
  fullWidth: { type: Boolean, required: false, default: true }
});
const buttonClasses = computed(() => {
  return {
    "primary-button": props.type === "primary",
    "secondary-button": props.type === "secondary",
    "full-width": props.fullWidth
  };
});
</script>

<style scoped>
.button{--border-radius-full:9999px;--color-blue-75:#e6edfa;--color-blue-300:#6184ca;--color-blue-500:#1850c1;--color-blue-500-hover:#1444a4;--color-grey-100:#e0e0e0;--color-text-secondary:#616161;--color-white:#fff;--space-200:8px;--space-400:16px;border-radius:var(--border-radius-full);color:var(--color-blue-500);cursor:pointer;font-size:16px;font-weight:400;line-height:22px;padding:var(--space-200) var(--space-400);transition:all .2s}.full-width{flex:1}.secondary-button{background:var(--color-white);border:1px solid var(--color-blue-300);border-radius:var(--border-radius-full);color:var(--color-blue-500)}.secondary-button:hover{background:var(--color-blue-75)}.primary-button:focus-visible,.secondary-button:focus-visible{outline:1px solid var(--color-blue-500);outline-offset:1px}.primary-button{background:var(--color-blue-500);border:none;border-radius:var(--border-radius-full);color:#fff;font-family:Inter;font-size:16px;font-weight:400;line-height:22px}.primary-button:hover{background:var(--color-blue-500-hover)}.primary-button:disabled{background:var(--color-grey-100);color:var(--color-text-secondary);cursor:not-allowed}
</style>
